import './index.css';
import '@fontsource/poppins/300.css';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/500.css';

import { createRoot } from 'react-dom/client';

import App from './App';
import CookiesManager from './modules/cookiesManagement';
import { initTranslation } from './shared/i18n';


try {
    initTranslation();

    window.GLBSCookiesManager = CookiesManager;

    const container = document.getElementById('root');

    if (!container) {
        throw new Error('Failed to find the root element');
    }

    const root = createRoot(container);

    root.render(<App />);

} catch (error) {
    // eslint-disable-next-line no-console
    console.error('Fatal initialization error:', error);

    const oldPortalPath = window.location.href.replace('/career', '');
    localStorage.setItem('redirectedFromNewPortal', 'true');
    window.location.replace(oldPortalPath);
}
